export default class FakturaceNahledPolozka {

    public name: string;
    public price: number;

}


// WEBPACK FOOTER //
// ./src/models/FakturaceNahledPolozka.tsx